import { useEffect } from "react";

function MusicHome() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="musicHome">
        </div>
    );
};

export default MusicHome;
